// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dc7be8e0","453":"4910f6a8","732":"7af64770"}[chunkId] + ".chunk.js";
};